/**
 * This module exports an enumeration `trafficSchoolStatus` that describes the user status in traffic school flow.
 */
export enum TrafficSchoolStatus {
  ENTERED = 'ENTERED',
  SUCCESS_ADD = 'SUCCESS_ADD',
  DL_EXISTS = 'DL_EXISTS',
  FAILED = 'FAILED',
  NOT_QUALIFIED = 'NOT_QUALIFIED',
}
